var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 22c-6,0 -11,-5 -11,-11 0,-6 5,-11 11,-11 6,0 11,5 11,11l0 11 -11 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.312540c1d5a3f3b03e102f3696370f2c.svg";
export { ForwardRef as ReactComponent };